module.exports = __webpack_public_path__ + "media/images/jobs/og-jobs-0df6db727f3b73d68746e3240f049277.jpg";